import axios from 'axios'

export default {
  generateStartNumber (event, amount) {
    return axios.get('startnumber/' + event + '/' + amount)
  }
}
